import { render, staticRenderFns } from "./form-item.vue?vue&type=template&id=89d61a5c&scoped=true"
import script from "./form-item.vue?vue&type=script&lang=js"
export * from "./form-item.vue?vue&type=script&lang=js"
import style0 from "./form-item.vue?vue&type=style&index=0&id=89d61a5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89d61a5c",
  null
  
)

export default component.exports